/**
 * Browser-local product history. Search keeps its native four-item default;
 * the product-page carousel can request a longer history and exclude itself.
 */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 12;
  static #memory = [];
  static #storageUnavailable = false;

  static #normalize(value) {
    if (!Array.isArray(value)) return [];
    return [...new Set(value.filter((id) => typeof id === 'string' && /^\d+$/.test(id)))].slice(0, this.#MAX_PRODUCTS);
  }

  static addProduct(productId) {
    if (typeof productId !== 'string' || !/^\d+$/.test(productId)) return;
    this.#memory = [productId, ...this.getProducts(this.#MAX_PRODUCTS).filter((id) => id !== productId)]
      .slice(0, this.#MAX_PRODUCTS);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(this.#memory));
    } catch {
      // Private browsing and storage limits must not interrupt the product page.
      this.#storageUnavailable = true;
    }
    window.dispatchEvent(new Event('recently-viewed:change'));
  }

  static clearProducts() {
    this.#memory = [];
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch { /* Storage may be unavailable. */ }
    window.dispatchEvent(new Event('recently-viewed:change'));
  }

  static getProducts(limit = 4) {
    if (this.#storageUnavailable) return this.#memory.slice(0, limit);
    try {
      this.#memory = this.#normalize(JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]'));
    } catch {
      // Retain the in-memory history when storage is blocked or malformed.
    }
    return this.#memory.slice(0, limit);
  }
}
